<template>
  <div class="db" :class="{ show: isActive }">
    <div class="header-wrap">
      <Header />
    </div>

    <div class="mainView mainView-aligned">
      <div v-if="billboardMovies" class="volatile-billboard-animations-container">
        <Billboard :click="showInfo" :item="billboardMovies" />
      </div>

      <VideoTeleport />

      <div ref="scrollContainer" class="slider-container">
        <template v-if="!searchMovies">
          <div v-for="category in mappedCategories" :key="category.id">
            <Slider v-if="category && category.infos" class="category-slider" :category="category" :cards="itemsArr" :isInfos="true" />
          </div>
        </template>
        <template v-else>
          <div class="search-title">{{ searchText }}</div>
          <div class="lists-content justify-content">
            <SliderItem v-for="item in searchMovies" :key="item.id" :item="item" :brandImage="brandImage" />
          </div>
        </template>
      </div>
    </div>

    <Footer class="member-footer" />
    <Loader class="loader" v-if="lazyLoading" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Header from '@/components/Header/Header';
import Loader from '@/components/Loader/Loader';
import SliderItem from '@/components/Slider/SliderItem.vue';
import Billboard from '@/components/Billboard/Billboard';
import Slider from '@/components/Slider/Slider';
import Footer from '@/components/Footer/Footer';
import VideoTeleport from '@/components/Slider/VideoTeleport';

export default {
  name: 'Movies',
  components: {
    VideoTeleport,
    Header,
    SliderItem,
    Billboard,
    Loader,
    Slider,
    Footer,
  },
  data() {
    return {
      offset: 0,
      lazyLoading: false,
      randomMovie: null,
      scrollAtTop: true,
      hasMoreData: true,
      scrollTimeout: null,
    };
  },
  computed: {
    ...mapGetters({ isTrial: 'isTrial' }),
    ...mapState({
      isActive: (state) => state.infoMovie.isActive,
      categories: (state) => state.movies.categories,
      searchMovies: (state) => state.movies.searchMovies,
      searchText: (state) => state.movies.searchText,
      brandImage: (state) => `/img/${state.config?.brandName}-logo.png`,
      isLoadingCategory: (state) => state.movies.isLoading,
      itemsArr: (state) => state.movies.movies,
    }),
    mappedCategories() {
      if (this.isTrial) {
        return this.categories?.map(({ infos, ...rest }) => ({
          ...rest,
          infos: infos.slice(0, 4),
        }));
      }
      return this.categories;
    },
    billboardMovies() {
      return this.randomMovie;
    },
  },
  watch: {
    categories: {
      handler(newVal) {
        if (newVal?.length && !this.randomMovie) {
          this.pickRandomMovie();
        }
      },
      immediate: false,
    },
  },
  methods: {
    showInfo() {
      this.$store.commit('handleGetInfoMovie', this.billboardMovies);
      this.$store.commit('handleShowInfoMovie', true);
    },

    loadCategories(offset) {
      this.$store.commit('finishedCategoryLoader', false);
      return this.$store.dispatch('initMoviesLoad', {
        offset,
        size: 3,
      });
    },

    handleScroll() {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        this.processScroll();
      }, 100);
    },

    async processScroll() {
      try {
        this.scrollAtTop = false;

        const element = this.$refs.scrollContainer;

        if (!element || this.lazyLoading || !this.hasMoreData) {
          return;
        }

        const rect = element.getBoundingClientRect();
        const threshold = window.innerHeight + 200;

        if (rect.bottom < threshold) {
          this.lazyLoading = true;
          this.offset += 3;

          const result = await this.$store.dispatch('loadMoreCategories', {
            offset: this.offset,
            size: 3,
          });

          if (!result || (Array.isArray(result) && result.length === 0)) {
            this.hasMoreData = false;
          }

          this.lazyLoading = false;
        }
      } catch (error) {
        console.error('Error in scroll handler:', error);
        this.lazyLoading = false;
      }
    },

    pickRandomMovie() {
      try {
        const recentAddedCategoryId = 2;
        const recentCategory = this.categories?.find((item) => item.id === recentAddedCategoryId);
        const infos = recentCategory?.infos || [];

        if (infos.length > 0) {
          const randomIndex = Math.floor(Math.random() * infos.length);
          this.randomMovie = infos[randomIndex];
        }
      } catch (error) {
        console.error('Error picking random movie:', error);
      }
    },

    cleanup() {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = null;
      }
      window.removeEventListener('scroll', this.handleScroll);
    },
  },

  async mounted() {
    try {
      await this.loadCategories(this.offset);
      this.pickRandomMovie();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    } catch (error) {
      console.error('Error in mounted hook:', error);
    }
  },

  beforeUnmount() {
    this.cleanup();
  },

  errorCaptured(err, instance, info) {
    console.error('Component error:', err, info);
    return false;
  },
};
</script>

<style scoped lang="scss">
.loader {
  position: sticky;
  bottom: 150px;
}
.db.show {
  height: 100.1vh;
  overflow: hidden;
}
</style>
